module.exports = __webpack_public_path__ + "static/media/ClutchWhite.327088fb.svg";